import { render, staticRenderFns } from "./MaFamille.vue?vue&type=template&id=2a46e596&scoped=true"
import script from "./MaFamille.vue?vue&type=script&lang=js"
export * from "./MaFamille.vue?vue&type=script&lang=js"
import style0 from "./MaFamille.vue?vue&type=style&index=0&id=2a46e596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46e596",
  null
  
)

export default component.exports